import { Text } from 'theme-ui';
import { priceSuffix } from '@/utils/CalculatorUtils';

interface PriceSuffixProps {
  unitType: string | null | undefined;
}

const PriceSuffix = ({ unitType }: PriceSuffixProps) => {
  const suffix = priceSuffix(unitType);
  if (!suffix) return null;
  return <Text sx={{ pl: 1, whiteSpace: 'nowrap' }}>{suffix}</Text>;
};

export default PriceSuffix;
